import { cn } from '@/lib/utils'
import {
  CardMain,
  CardStory,
  CardVertical,
  Section,
  SectionHeader,
  Slide,
  Slider
} from '@/ui/components'
import { cva } from 'class-variance-authority'
import { memo } from 'react'
import { SectionFeatureProps } from './type'

const SectionFeature = ({
  slidesPerView,
  spaceBetween,
  section,
  overline,
  titleLayout,
  title,
  buttons,
  items,
  variant = 'content',
  className
}: SectionFeatureProps) => {
  if (!items || !items.length) {
    return null
  }

  const sectionVariants = cva('', {
    variants: {
      variant: {
        shop: 'bg-shop-100 text-neutral-600',
        event: '',
        topEvent: 'bg-accent-300 text-neutral-100',
        content: '',
        story: '',
        tour: '',
        hotel: '',
        restBarShop: ''
      }
    },
    defaultVariants: {
      variant: 'content'
    }
  })

  const mode = variant === 'topEvent' ? 'invert' : 'default'

  let slidesPerViewFinal = slidesPerView
  if (variant === 'restBarShop') {
    slidesPerViewFinal = 3
  } else if (variant === 'topEvent' || variant === 'shop') {
    slidesPerViewFinal = 3
  } else {
    slidesPerViewFinal = 3
  }

  return (
    <Section
      data={section}
      className={cn(
        's-section-feature',
        sectionVariants({ variant, className })
      )}
    >
      <SectionHeader
        title={title}
        titleLayout={titleLayout}
        overline={overline}
        buttons={buttons}
        mode={mode}
      />
      <Slider
        className="pt-md"
        slidesPerView={slidesPerViewFinal}
        spaceBetween={spaceBetween}
        showProgressBar={true}
      >
        {items?.map((item, index) => (
          <Slide key={index?.toString()}>
            {variant === 'topEvent' ||
            variant === 'content' ||
            variant === 'event' ||
            variant === 'restBarShop' ? (
              <CardMain variant={variant} {...item} />
            ) : null}
            {variant === 'shop' && <CardVertical {...item} />}
            {variant === 'story' && <CardStory {...item} />}
          </Slide>
        ))}
      </Slider>
    </Section>
  )
}

SectionFeature.displayName = 'SectionFeature'

export default memo(SectionFeature)
